import { ChevronUpIcon } from '@heroicons/react/24/solid';
import useNearBottom from '../../hook/useNearBottom';

const ScrollToTop = () => {
	const { isNearBottom, scrollToTop } = useNearBottom();

	if (!isNearBottom) return null;

	return (
		<div className="fixed bottom-4 inset-x-0 z-[5] pointer-events-none">
			<div className="max-w-3xl mx-auto px-4 flex justify-end">
				<div
				className="pointer-events-auto bg-[var(--rose-violet)] p-2 cursor-pointer text-white rounded-md"
				onClick={scrollToTop}
				>
				<ChevronUpIcon className="w-4 h-4" />
				</div>
			</div>
		</div>
	);
};

export default ScrollToTop;
